import { toDate } from "@/utils/utils";
import { Collapse, Tag } from "antd";
import dayjs from "dayjs";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Insurance, InsuranceContract } from "../../../../types";
import { AdditionalContractInsuranceData } from "./AdditionalContractInsuranceData";
import InsuranceHeaderView from "./InsuranceHeaderView";

interface Props {
  insurance: Insurance;
  contract: InsuranceContract;
  index: number;
  multipleInsurances: boolean;
  activeKeys: string[];
  onActiveKeysChange: (keys: string[]) => void;
  children: ReactNode;
}

export const InsuranceCollapseView = ({
  insurance,
  contract,
  index,
  multipleInsurances,
  activeKeys,
  onActiveKeysChange,
  children,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Collapse
      activeKey={activeKeys}
      onChange={(key) => onActiveKeysChange(key as string[])}
      items={[
        {
          key: insurance.id,
          label: (
            <>
              {multipleInsurances && `${index + 1}. `}
              <InsuranceHeaderView insurance={insurance} contract={contract} />
            </>
          ),
          extra: (
            <span onClick={(event) => event.stopPropagation()}>
              {multipleInsurances && (
                <>
                  {toDate(insurance.contractEntryDate)?.isAfter(dayjs(), "day") && (
                    <Tag color="green">{t("contract.helpers.insuranceBeforeEntry")}</Tag>
                  )}
                  {insurance.contractWithdrawalDate &&
                    toDate(insurance.contractWithdrawalDate)?.isBefore(dayjs(), "day") && (
                      <Tag color="geekblue">{t("contract.helpers.insuranceAfterWithdrawal")}</Tag>
                    )}
                </>
              )}
            </span>
          ),
          children: (
            <>
              {multipleInsurances && <AdditionalContractInsuranceData insurance={insurance} />}

              {children}
            </>
          ),
        },
      ]}
    />
  );
};
